import React, { useCallback, useEffect, useState, useRef } from "react";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import projectService from "../../../store/services/projects.service";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../store/actions";
import { debounce } from 'lodash';

import "./Appendix.scss";
import Skeleton from "react-loading-skeleton";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import ModalCheckbox from "../../../components/controls/modalcheckbox/ModalCheckbox";
import { AttachementRefType } from "../../../store/services/attachments.service";

const Appendix = (props) => {
  const { parentId, appendix, onAppendixNameChange } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [content, setContent] = useState("");
  const [currentAppendix, setCurrentAppendix] = useState(null);
  const dispatch = useDispatch();
  const apendixNamedebounced = useRef(debounce(({value,appendixId}) => handleUpdateAppendixName(value,appendixId), 1000));
  const apendixContentdebounced = useRef(debounce(({value,appendixId}) => handleUpdateAppendixContent(value,appendixId), 1000));
  const isOverviewHeaderCollapsed = localStorage.getItem("isOverviewHeaderCollapsed") === "true";

  const handleUpdateAppendixContent = (value, appendixId) => {    
    const data = {
      projectId: parentId,
      appendixId: appendixId,
      payload: {appendix : value}
    }
    projectService.updateProjectAppendixRequest(data);
  };

  const handleAppendixContentChange = useCallback((value, appendixId) => {
    if(appendixId && !isLoading){
      setContent(value);
      setCurrentAppendix(prev => ({
        ...prev,
        appendix: value
      }));
      apendixContentdebounced.current({value, appendixId});
    }
    
  }, []);

  const handleUpdateAppendixName = (value, appendixId) => {    
    const data = {
      projectId: parentId,
      appendixId: appendixId,
      payload: {name : value}
    }
    projectService.updateProjectAppendixRequest(data);
  };

  const handleAppendixNameChange = useCallback((value, appendixId) => {
    if(!value)
      return;
    setCurrentAppendix(prev => ({...prev, name: value}));
    onAppendixNameChange({id: appendixId, name:value});
    apendixNamedebounced.current({value, appendixId});
  }, []);

  const handleAppendixInWSRChange = (value) => {
    
    const data = {
      projectId: parentId,
      appendixId: currentAppendix.id,
      payload: {inWSR : value}
    }
    setIsSaveLoading(true);
    projectService.updateProjectAppendixRequest(data).then(() => {
                        setCurrentAppendix(prev => ({...prev, inWSR: value}))
                        })
                        .catch(() => {
                            dispatch(
                                    generalActions.showToast({
                                        title: "Something went wrong. Please try again later.",
                                        type: "error",
                                    })
                                    );
                        })
                        .finally(() => {
                          setIsSaveLoading(false);
                        });
  };
  
  useEffect(() => {
    if (appendix) {
      setIsLoading(true);
      projectService.getProjectAppendixRequest(parentId, appendix.id)
                    .then((data) => {
                            setContent(data.appendix);
                            setCurrentAppendix(data);
                        })
                        .catch(() => {
                            dispatch(
                                    generalActions.showToast({
                                        title: "Something went wrong. Please try again later.",
                                        type: "error",
                                    })
                                    );
                        })
                        .finally(() => {
                          setIsLoading(false);
                        });
    }
  }, [appendix]);


  useEffect(() => {
    if(!isLoading && document.querySelector(".ProseMirror")){
      document.querySelector(".ProseMirror").style.setProperty("min-height", `calc(100vh - ${isOverviewHeaderCollapsed ? '303' : '500'}px)`);
      document.querySelector(".ProseMirror").style.setProperty("max-height", `calc(100vh - ${isOverviewHeaderCollapsed ? '303' : '500'}px)`);
    }
      
  }, [isLoading, isOverviewHeaderCollapsed, document.querySelector(".ProseMirror")]);

  return (
    <div className="appendix-container">
      {isLoading ? 
      <Skeleton height={50} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
      :
      <div className="flex col mx-1 mb-1">
        <div className="col-10">
          <InputUnderline
            placeholder=""
            value={currentAppendix?.name}
            handleChange={(val) => handleAppendixNameChange(val,currentAppendix?.id)}
            loading={isLoading}
          />
        </div>
        <div className="flex col-2 justify-end">
        <ModalCheckbox
              label={`${currentAppendix?.inWSR? "Included In" : "Add to"} Status Report`}
              checked={currentAppendix?.inWSR}
              setChecked={handleAppendixInWSRChange}
              loading= {isLoading || isSaveLoading}
            />
        </div>
      </div>
      
      }
      
      <div 
        className="CustomCard"
        style={
          {
            minHeight:`calc(100vh - ${isOverviewHeaderCollapsed === true ? '303' : '500'}px)`,
            maxHeight:`calc(100vh - ${isOverviewHeaderCollapsed === true ? '303' : '500'}px)`
          }
          }>
        <div>
            <RichTextEditor 
              mode="advanced" 
              content={content} 
              onChange={(val) => handleAppendixContentChange(val,currentAppendix?.id)}
              fileUploadParams={{ enabled: true, refType: AttachementRefType.Appendix, refId: currentAppendix?.id }}
              loading={isLoading}/>
        </div>
      </div>
    </div>
  );
};
export default Appendix;
